/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import { Button, Table, Input, Tag, Modal, Form, message } from 'antd';
import {
  FileExcelOutlined,
  FilterFilled,
  FilterOutlined,
  SendOutlined

} from '@ant-design/icons';
import { ColumnProps } from 'antd/es/table';
import useObtenerIngresos from '../../hooks/useObtenerIngresos';
import { useObtenerIngresosById } from '../../hooks/useObtenerIngresosById';

import useGrabarPrefactura from '../../hooks/useGrabarPrefactura';

import { useUser } from '../../hooks/useUser';

import moment from 'moment';
import './IngresosTable.scss';
import * as XLSX from 'xlsx';
import IngresosTable from '../ingresos/IngresosTable';


interface InformeTableProps {
  id?: string | null;
  fecha_inicio: string;
  fecha_fin: string;
  estados: string[];
  setTotalRegistros: (value: number) => void;
  setTotalValor: (value: number) => void;
  onOpenModal: () => void;
  resetFiltersAndReload: () => void;
}

const InformeTable: React.FC<InformeTableProps> = ({
  id,
  fecha_inicio,
  fecha_fin,
  estados,
  setTotalRegistros,
  setTotalValor,
  onOpenModal
}) => {
  const { ingresos, cargando, error } = useObtenerIngresos(id, fecha_inicio, fecha_fin, estados);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [activeFilters, setActiveFilters] = useState({});
  const tableDataRef = useRef<any[]>([]);

  const [isEntregaModalOpen, setIsEntregaModalOpen] = useState(false);
  const [ingresoSeleccionadoId, setIngresoSeleccionadoId] = useState<number | null>(null);

  const tipoEstado = [
    { text: 'Ingresado', value: 'ingresado' },
    { text: 'Entregado', value: 'entregado' },
    { text: 'Anulado', value: 'anulado' }
  ];

  const sucursales = [
    { text: 'Bello', value: 'Bello' },
    { text: 'Envigado', value: 'Envigado' },
    { text: 'Laureles', value: 'Laureles' },
    { text: 'Oviedo', value: 'Oviedo' },
    { text: 'Robledo', value: 'Robledo' },
    { text: 'San Lucas', value: 'San Lucas' }
  ];

  useEffect(() => {
    if (ingresos) {
      tableDataRef.current = ingresos;
      applyFiltersAndSearch(ingresos, searchTerm, activeFilters);
    }
  }, [ingresos, searchTerm, activeFilters]);

  const handleSearch = (value: string) => {
    setSearchTerm(value.toLowerCase());
  };

  const applyFiltersAndSearch = (data: any[], search: string, filters: any) => {
    let filtered = data;

    if (search) {
      filtered = filtered.filter(
        (item) =>
          item.sucursal.toLowerCase().includes(search) ||
          item.vehiculo_placa.toLowerCase().includes(search) ||
          item.cliente_nombre.toLowerCase().includes(search) ||
          item.servicios.toLowerCase().includes(search)
      );
    }

    if (filters.sucursal && filters.sucursal.length > 0) {
      filtered = filtered.filter((item) => filters.sucursal.includes(item.sucursal));
    }

    if (filters.estado && filters.estado.length > 0) {
      filtered = filtered.filter((item) => filters.estado.includes(item.estado));
    }

    setFilteredData(filtered);
    updateTotals(filtered);
  };

  const updateTotals = (data: any[]) => {
    setTotalRegistros(data.length);
    const sumaTotal = data.reduce((acc, curr) => {
      const valor = Number(curr.valor_total) || 0;
      return acc + valor;
    }, 0);
    setTotalValor(sumaTotal);
  };

  const handleTableChange = (pagination, filters, sorter, extra) => {
    setActiveFilters(filters);
  };

  const handleDownloadExcel = () => {
    const data = filteredData.length ? filteredData : ingresos;

    const formattedData = data.map((row: any) => ({
      Ingreso: row.ingreso_id,
      Sucursal: row.sucursal,
      Placa: row.vehiculo_placa,
      Servicios: row.servicios,
      Valor: row.valor_total,
      Cliente: row.cliente_nombre,
      Celular: row.celular,
      Estado: row.estado,
      FechaCreación: moment(row.fecha_creacion).format('DD/MM/YYYY HH:mm:ss')
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Datos Filtrados');
    XLSX.writeFile(workbook, 'Aprisa_Reporte.xlsx');
  };

  const handleOpenEntregaModal = (ingreso: any) => {
    setIngresoSeleccionadoId(ingreso.ingreso_id);
    setIsEntregaModalOpen(true);
  };

  const columns: ColumnProps<any>[] = [
    {
      key: 'actions',
      title: 'Acc',
      width: 100,
      render: (ingreso) => (
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100px' }}>
          {ingreso.estado === 'entregado' && (
            <Button
              icon={<SendOutlined />}
              shape='circle'
              style={{ color: 'greenyellow' }}
              onClick={() => handleOpenEntregaModal(ingreso)}
            />
          )}
        </div>
      )
    },
    {
      key: 'ingreso_id',
      dataIndex: 'ingreso_id',
      title: 'Ingreso'
    },
    {
      key: 'sucursal',
      dataIndex: 'sucursal',
      title: 'Sucursal',
      filters: sucursales,
      onFilter: (value: string | number | boolean, record: any) => record.sucursal === value,
      filterMultiple: true,
      filterIcon: (filtered: boolean) => (
        <FilterFilled style={{ color: filtered ? '#ff4d4f' : '#ff4d4f' }} />
      )
    },
    {
      key: 'usuario_id',
      dataIndex: 'usuario_id',
      title: 'Id User',
      onCell: () => ({
        style: { display: 'none' }
      }),
      onHeaderCell: () => ({
        style: { display: 'none' }
      })
    },
    {
      key: 'placa',
      dataIndex: 'vehiculo_placa',
      title: 'Placa'
    },
    {
      key: 'servicios',
      dataIndex: 'servicios',
      title: 'Servicios',
      render: (text: string) => <span style={{ fontSize: '10px' }}>{text}</span>
    },
    {
      key: 'valor_total',
      dataIndex: 'valor_total',
      title: 'Valor',
      render: (valor: number) => (
        <div style={{ textAlign: 'right' }}>
          <span className='nowrap' style={{ color: '#336cfb' }}>
            {new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP' }).format(valor)}
          </span>
        </div>
      )
    },
    {
      key: 'cliente_nombre',
      dataIndex: 'cliente_nombre',
      title: 'Cliente'
    },
    {
      key: 'celular',
      dataIndex: 'celular',
      title: 'Celular',
      render: (phone: string) => (
        <span className='d-flex align-baseline nowrap' style={{ color: '#336cfb' }}>
          <span className='icofont icofont-ui-cell-phone mr-1' style={{ fontSize: 16 }} /> {phone}
        </span>
      )
    },
    {
      key: 'estado',
      dataIndex: 'estado',
      title: 'Estado',
      filters: tipoEstado,
      onFilter: (value: string | number | boolean, record: any) => record.estado === value,
      filterMultiple: true,
      render: (estado: string) => {
        let color;
        switch (estado) {
          case 'ingresado':
            color = '#FFC300';
            break;
          case 'entregado':
            color = '#b7ce63';
            break;
          case 'anulado':
            color = '#ff7f7f';
            break;
          default:
            color = '#d9d9d9';
        }

        return (
          <Tag style={{ borderRadius: 20 }} color={color}>
            {estado}
          </Tag>
        );
      },
      filterIcon: (filtered: boolean) => (
        <FilterFilled style={{ color: filtered ? '#ff4d4f' : '#ff4d4f' }} />
      )
    },
    {
      key: 'fecha_creacion',
      dataIndex: 'fecha_creacion',
      title: 'Fecha Creación',
      render: (fecha: string) => {
        const formattedDate = moment.utc(fecha).format('DD/MM/YYYY HH:mm:ss');
        return <span style={{ fontSize: '10px' }}>{formattedDate}</span>;
      }
    }
  ];
  if (error) {
    return <p>Error al cargar los datos: {error.message}</p>;
  }
  const pagination = ingresos?.length <= 10 ? false : {};

  return (
    <>
      <div className='row'>
        <div className='mb-0'>
          <Button
            type='primary'
            onClick={onOpenModal}
            icon={<FilterOutlined />}
            style={{ width: '40px', marginBottom: '10px', marginLeft: '10px' }}
          />

          <Button
            type='primary'
            onClick={handleDownloadExcel}
            icon={<FileExcelOutlined />}
            style={{
              width: '40px',
              marginBottom: '10px',
              marginLeft: '20px',
              backgroundColor: '#28a745',
              borderColor: '#28a745'
            }}
          />
        </div>
        <div className='col-md-2 col-sm-12' style={{ position: 'relative' }}>
          <Input
            placeholder='Buscar...'
            style={{ marginBottom: '10px' }}
            onChange={(e) => handleSearch(e.target.value)}
          />
        </div>
      </div>

      <Table
        loading={cargando}
        className='accent-header'
        dataSource={filteredData}
        columns={columns}
        rowKey='id'
        pagination={pagination}
        onChange={handleTableChange}
      />

      {isEntregaModalOpen && (
        <EntregarIngresoModal
          visible={isEntregaModalOpen}
          onClose={() => setIsEntregaModalOpen(false)}
          ingresoId={ingresoSeleccionadoId}
        />
      )}
    </>
  );
};

export default InformeTable;

const EntregarIngresoModal: React.FC<{
  visible: boolean;
  onClose: () => void;
  ingresoId: number | null;
}> = ({ visible, onClose, ingresoId }) => {
  const [form] = Form.useForm();

  const { ingreso, cargando, error } = useObtenerIngresosById(ingresoId);
  const {
    grabarPrefactura,
    loading: prefacturaLoading,
  
  } = useGrabarPrefactura();
  const { user } = useUser();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const columns = [
    {
      title: 'Ref',
      dataIndex: 'referencia',
      key: 'referencia',
      render: (text) => <span style={{ fontSize: '10px' }}>{text}</span>
    },
    {
      title: 'Producto',
      dataIndex: 'producto',
      key: 'producto',
      render: (text) => <span style={{ fontSize: '10px' }}>{text}</span>
    },
    {
      title: 'Subtotal',
      dataIndex: 'precio_con_iva',
      key: 'precio_con_iva',
      render: (valor) => {
        const formattedValue = new Intl.NumberFormat('es-CO', {
          style: 'currency',
          currency: 'COP'
        }).format(valor);
        return <span style={{ fontSize: '10px' }}>{formattedValue}</span>;
      }
    },
    {
      title: 'Iva',
      dataIndex: 'precio_antes_iva',
      key: 'precio_antes_iva',
      render: (valor) => {
        const formattedValue = new Intl.NumberFormat('es-CO', {
          style: 'currency',
          currency: 'COP'
        }).format(valor);
        return <span style={{ fontSize: '10px' }}>{formattedValue}</span>;
      }
    },
    {
      title: 'Descuento',
      dataIndex: 'valor_descuento',
      key: 'valor_descuento',
      render: (valor) => {
        const formattedValue = new Intl.NumberFormat('es-CO', {
          style: 'currency',
          currency: 'COP'
        }).format(valor);
        return <span style={{ fontSize: '10px' }}>{formattedValue}</span>;
      }
    },
    {
      title: 'Total',
      dataIndex: 'neto',
      key: 'neto',
      render: (valor) => {
        const formattedValue = new Intl.NumberFormat('es-CO', {
          style: 'currency',
          currency: 'COP'
        }).format(valor);
        return <span style={{ fontSize: '10px' }}>{formattedValue}</span>;
      }
    }
  ];

  const handleEntregar = async () => {
    if (!ingreso) {
      message.error('No hay ingreso cargado');
      return;
    }
    const prefacturaData = {
      tipoDocumento: 9,
      id_sucursal: 1,
      id_bodega: 1,
      id_vendedor: ingreso.empleado_id,
      id_empleado: ingreso.empleado_id,
      fecha_registro: Date.now(),
      nota: ingreso.placa,
      total_neto: ingreso.valor_total,
      total_impuestos: ingreso.iva,
      total_sin_impuestos: ingreso.subtotal,
      codigo_unico: ingresoId,
      lstPagos: [
        {
          id_medio_pago: 1,
          id_banco: 1,
          valor: ingreso.valor_total,
          boucher: '',
          digitos: '',
          devuelta: 0,
          dinero_entregado: ingreso.valor_total,
          nota: '',
          fecha_registro: Date.now()
        }
      ],
      objClienteMini: {
        id_cliente: ingreso.id_cliente_erp,
        nombre_cliente: ingreso.nombres,
        identificacion: ingreso.cedula,
        telefono1: ingreso.celular || '',
        telefono2: '',
        email1: ingreso.correo || 'facturag4@gmail.com',
        direccion: ingreso.direccion || 'Medellín',
        regimen: 1,
        es_cliente: 1,
        es_proveedor: 0
      },
      objDetalle: ingreso.productos.map((producto) => ({
        sku: producto.referencia,
        precio_venta: producto.precio_con_iva,
        cantidad: 1,
        impuesto: 19,
        total: producto.neto,
        descripcion: producto.producto
      }))
    };

    console.log('Datos Prefactura:', prefacturaData);

    await grabarPrefactura(prefacturaData);

    message.success(`Se entregó el ingreso ${ingresoId}.`);
  };

  return (
    <Modal
      title={`Entrega Número: ${ingresoId}`}
      open={visible}
      onCancel={() => {
        onClose();
      }}
      maskClosable={false}
      footer={null}
    >
      {cargando ? (
        <p>Cargando...</p>
      ) : error ? (
        <p>Error: {error.message}</p>
      ) : (
        ingreso && (
          <Form form={form} layout='vertical'>
            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}></div>

            <div
              style={{
                height: '100px',
                display: 'flex',
                justifyContent: 'left',
                padding: '0px'
              }}
              className='animated with-shadow'
            >
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <div style={{ display: 'flex', marginBottom: '4px' }}>
                  <strong
                    style={{
                      color: 'royalblue',
                      display: 'inline-block',
                      marginRight: '4px'
                    }}
                  >
                    Placa:
                  </strong>
                  <span>{ingreso.placa}</span>
                </div>
                <div style={{ display: 'flex', marginBottom: '4px', marginRight: '4px' }}>
                  <strong
                    style={{
                      color: 'royalblue',
                      display: 'inline-block',
                      marginRight: '4px'
                    }}
                  >
                    Cliente:
                  </strong>
                  <span>{ingreso.nombres}</span>
                </div>
                <div style={{ display: 'flex' }}>
                  <strong style={{ color: 'royalblue', display: 'inline-block' }}>
                    Identificación:
                  </strong>
                  <span>{ingreso.cedula}</span>
                </div>
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '40px' }}>
                <div style={{ display: 'flex', marginBottom: '4px' }}>
                  <strong
                    style={{
                      color: 'royalblue',
                      display: 'inline-block',
                      marginRight: '4px'
                    }}
                  >
                    Celular:
                  </strong>
                  <span>{ingreso.celular}</span>
                </div>
                <div style={{ display: 'flex' }}>
                  <strong
                    style={{
                      color: 'royalblue',
                      display: 'inline-block',
                      marginRight: '4px'
                    }}
                  >
                    Correo:
                  </strong>
                  <span>{ingreso.correo}</span>
                </div>
                <div style={{ display: 'flex' }}>
                  <strong
                    style={{
                      color: 'royalblue',
                      display: 'inline-block',
                      marginRight: '4px'
                    }}
                  >
                    Id_Cliente_ERP:
                  </strong>
                  <span>{ingreso.id_cliente_erp} - {ingreso.empleado_id}</span>
                </div>
              </div>
            </div>

            <Table
              className='accent-header'
              dataSource={ingreso.productos}
              columns={columns}
              pagination={false}
              style={{ marginBottom: '10px' }}
              rowKey='referencia'
            />
            <Input
              addonBefore={<span className='custom-addon'>SubTotal:</span>}
              value={new Intl.NumberFormat('es-CO', {
                style: 'currency',
                currency: 'COP'
              }).format(ingreso.subtotal)}
              readOnly
              style={{ marginBottom: '2px', width: '100%', textAlign: 'right', color: '#336cfb' }}
            />
            <Input
              addonBefore={<span className='custom-addon'>Impuesto:</span>}
              value={new Intl.NumberFormat('es-CO', {
                style: 'currency',
                currency: 'COP'
              }).format(ingreso.iva)}
              readOnly
              style={{ marginBottom: '2px', width: '100%', textAlign: 'right', color: '#336cfb' }}
            />
            <Input
              addonBefore={<span className='custom-addon'>Descuento:</span>}
              value={new Intl.NumberFormat('es-CO', {
                style: 'currency',
                currency: 'COP'
              }).format(ingreso.descuento)}
              readOnly
              style={{ marginBottom: '2px', width: '100%', textAlign: 'right', color: '#336cfb' }}
            />
            <Input
              addonBefore={<span className='custom-addon'>Total:</span>}
              value={new Intl.NumberFormat('es-CO', {
                style: 'currency',
                currency: 'COP'
              }).format(ingreso.valor_total)}
              readOnly
              style={{ marginBottom: '5px', width: '100%', textAlign: 'right', color: '#336cfb' }}
            />

            <div style={{ display: 'flex', gap: '10px' }}>
              <Button
                type='primary'
                onClick={handleEntregar}
                loading={prefacturaLoading || isSubmitting}
              >
                ENVIAR
              </Button>
            </div>
          </Form>
        )
      )}
    </Modal>
  );
};
